import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrefixInputComponent } from './prefix-input.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [PrefixInputComponent],
    declarations: [PrefixInputComponent],
    providers: [],
})
export class PrefixInputModule { }
